import BaseValidator from 'services/validations/base-validator';
import Const from 'const';

class SingleSecondaryStackCombinationsValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking, sportConfig} = this.dependencies;
        const items = stacking.getItems();
        const QBPositionQuantityInLineup = 1;
        const playersInLineup = sportConfig.getConfigProp('playersInTeam', 0);

        items.forEach((item) => {
            if (!item.isSecondaryStackTypeSingle()) {
                return;
            }

            let minStackPlayersQuantity = item.getFirstTeamAtLeastPlayers();
            if (item.isGameStackType()) {
                minStackPlayersQuantity += item.getSecondTeamAtLeastPlayers();
            }

            const uncoveredPositions = playersInLineup - (QBPositionQuantityInLineup + minStackPlayersQuantity);
            if (uncoveredPositions > Const.CORRELATION_SECONDARY_STACK_COMBINATION_PLAYERS_QUANTITY) {
                return;
            }

            const combinations = item.getSecondaryStackCombinations();
            for (let key in combinations) {
                const isKeyCombination = Const.SECONDARY_STACK_COMBINATION_TYPE_4 === Number(key);

                if (isKeyCombination && !combinations[key]) {
                    this.addError(
                        `Please, enable "RB + DEF same team" combination for stacks with "No less than" ${minStackPlayersQuantity} Players in total.`,
                    );
                }
            }
        });
    }
}

export default SingleSecondaryStackCombinationsValidator;
